export default "__VITE_ASSET__DrVTGHAO__"